"use client";

import Image from "next/image";
import { useState } from "react";
import PayInInstallmentsModal from "@/components/modals/product-related/PayInInstallmentsModal";
import classes from "./PayInInstallments.module.css";

const PayInInstallments = ({ listing }) => {
  const [payInInstallmentsModal, setPayInInstallmentsModal] = useState();

  return (
    <>
      <PayInInstallmentsModal
        setPayInInstallmentsModal={setPayInInstallmentsModal}
        payInInstallmentsModal={payInInstallmentsModal}
        price={listing.price}
      />
      <div className={classes.paypalDesc}>
        <p
          className={classes.payIn}
          onClick={() => setPayInInstallmentsModal(true)}
        >
          Pay $
          {((listing.price + listing.price * 0.086) / 4).toLocaleString(
            undefined,
            {
              maximumFractionDigits: 0,
            }
          )}
          /month
        </p>
        <div className={classes.roundPay}>
          <Image
            width={24}
            alt="paypal logo"
            height={24}
            className={classes.paypalLogo}
            src={
              "https://ik.imagekit.io/kuj9zqlrx0or/Static/Paypal-512.webp?tr=w-50"
            }
          />
        </div>
      </div>
    </>
  );
};

export default PayInInstallments;
